module.exports = __webpack_public_path__ + "assets/img/922129.29dd46c3.jpg";